import { Controller } from "@hotwired/stimulus"

// Client-side sort for a table that renders every row (lists index): a click on a sortable header
// orders the <tbody> rows by that column, a second click flips the order. Headers opt in through
// the sort_th helper (data-table-sort-type="text|number|date", aria-sort); a cell whose text is
// not its key — a formatted count, a time — gives it in data-sort-value (numbers unformatted,
// times as epoch seconds). Blank keys go last either way; ties keep the server's order. For
// paginated tables the server's ordering is the right tool — this is for full-render pages.
export default class extends Controller {
  connect() {
    this.rows().forEach((row, i) => { row.dataset.tableSortIndex = i })
  }

  sort(event) {
    const th = event.currentTarget.closest("th")
    const headers = Array.from(th.parentElement.children)
    const column = headers.indexOf(th)
    const direction = th.getAttribute("aria-sort") === "ascending" ? "descending" : "ascending"
    headers.forEach(h => { if (h.hasAttribute("aria-sort")) h.setAttribute("aria-sort", h === th ? direction : "none") })

    const type = th.dataset.tableSortType || "text"
    const sign = direction === "ascending" ? 1 : -1
    const keyed = this.rows().map(row => ({ row, key: this.key(row.children[column], type), order: Number(row.dataset.tableSortIndex) }))
    keyed.sort((a, b) => {
      if (a.key === null || b.key === null) return (a.key === null ? 1 : 0) - (b.key === null ? 1 : 0) || a.order - b.order
      return sign * this.compare(a.key, b.key, type) || a.order - b.order
    })
    const tbody = this.element.querySelector("tbody")
    keyed.forEach(({ row }) => tbody.appendChild(row))
  }

  key(cell, type) {
    if (!cell) return null
    const raw = cell.dataset.sortValue ?? cell.textContent
    if (type === "number") {
      const n = parseFloat(String(raw).replace(/[^0-9.\-]/g, ""))
      return Number.isNaN(n) ? null : n
    }
    if (type === "date") {
      const n = cell.dataset.sortValue !== undefined ? parseFloat(cell.dataset.sortValue) : Date.parse(raw)
      return Number.isNaN(n) ? null : n
    }
    const s = String(raw).replace(/\s+/g, " ").trim().toLowerCase()
    return s === "" ? null : s
  }

  compare(a, b, type) { return type === "text" ? a.localeCompare(b) : a - b }

  rows() { return Array.from(this.element.querySelectorAll("tbody tr")).filter(r => !r.querySelector("td.empty")) }
}
